export interface ApiErrorBody {
  message?: string
  code?: string
  details?: {
    visit?: string
    validation_errors?: { field: string; message: string; reason: string }[]
  }
}

export class ApiResponseError extends Error {
  readonly code?: string
  readonly details?: ApiErrorBody['details']

  constructor(
    readonly statusCode: number,
    readonly responseError: ApiErrorBody,
  ) {
    super(responseError.message || `Request failed (${statusCode})`)
    this.name = 'ApiResponseError'
    this.code = responseError.code
    this.details = responseError.details
  }
}

export class NetworkError extends Error {
  constructor(cause: unknown) {
    super('Unable to reach the server', { cause })
    this.name = 'NetworkError'
  }
}

export class PaginationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PaginationError'
  }
}
